import React, { useRef, useState, useEffect } from "react";
import "./doctorSpecialization.css";
import Widgets from "../../widgets";
import ToastPopup from "../../widgets/Toast/toastPopup";
import AddDepartment from "../addDepartment/addDepartment";
import { useTranslation } from "react-i18next";
import { toggleActiveDepartment } from "../../modules/department/departmentThunk";
import { resetToggleActiveDept, resetDeptSuggestion } from "../../modules/department/departmentSlice";
import { useDispatch, useSelector } from "react-redux";

const AddSpeciality = ({ setSelectedView }) => {
  const breadcrumbs = ["video_Consultation", "departments"];
  const dispatch = useDispatch();
  const { toggleActiveDept, toggleActiveDeptError } = useSelector((state) => state.department);
  const paths = [{ path: "/department", onClick: () => setSelectedView("doctorSpecialization") }, "/department"];
  const { t } = useTranslation();
  const [isActivate, setIsActivate] = useState(true);
  const [departmentId, setDepartmentId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editDepName, setEditDepName] = useState("");

  useEffect(() => {
    if (toggleActiveDeptError) {
      ToastPopup.error(toggleActiveDeptError);
      setSelectedView("doctorSpecialization");
    }
    if (toggleActiveDept && toggleActiveDept.status === "success" && toggleActiveDept.data.department.isActive) {
      ToastPopup.success(t("departmentActivated"));
      setSelectedView("doctorSpecialization");
    }
    dispatch(resetToggleActiveDept());
  }, [toggleActiveDept, toggleActiveDeptError]);

  const handleCancel = () => {
    dispatch(resetDeptSuggestion());
    setSelectedView("doctorSpecialization");
  };

  const addSpecialityRef = useRef();

  const handleSave = () => {
    if (addSpecialityRef.current) {
      addSpecialityRef.current.saveSpeciality();
    }
  };

  const truncateText = (text) => {
    if (text.length > 40) {
      return text.slice(0, 40) + "...";
    }
    return text;
  };

  const handleActivate = (selectedSuggestion) => {
    if (selectedSuggestion) {
      setIsActivate(selectedSuggestion.isActive);
    } else {
      setIsActivate(true);
    }
    setDepartmentId(selectedSuggestion._id);
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    dispatch(toggleActiveDepartment(departmentId));
  };

  return (
    <div className="department-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading-row">
        <div className="department-heading">{editDepName ? truncateText(editDepName) : t("createDepartment")}</div>
        {!isActivate && (
          <div className="department-update-btn" onClick={() => handleDelete()}>
            {t("activate")}
          </div>
        )}
      </div>
      <div className="department-speciality-box">
        <div className="speciality-head">
          <div className="speciality-name">
            {t("specialityen")}
            <span className="astrik">*</span>
          </div>
          <div className="speciality-name">
            {t("specialityvn")}
            <span className="astrik">*</span>
          </div>
        </div>

        <div className="add-speciality">
          <AddDepartment ref={addSpecialityRef} setSelectedView={setSelectedView} ifActivate={handleActivate} setEditDepName={setEditDepName} />
        </div>
        <div className="save-speciality add-department-btn">
          <div className="speciality-cancel" onClick={handleCancel}>
            {t("cancel")}
          </div>
          {isActivate && (
            <div className="speciality-save" onClick={handleSave}>
              {t("save")}
            </div>
          )}
        </div>
      </div>
      <Widgets.ConfirmModal showModal={showDeleteModal} handleCancel={handleCancelDelete} handleConfirm={handleConfirmDelete} heading="cnfActivateHead" description="askActivate" postive />
    </div>
  );
};

export default AddSpeciality;
